import React, { useEffect, useRef, useState } from "react";
import "./FixedImageSection.css";

/**
 * Static image hero section
 * - Background image is static (no parallax)
 * - Text is fixed and centered
 * - Font: Montserrat
 */

export default function FixedImageSection() {
  // Pexels spa/massage image
  const IMG = "./headerthree.webp";

  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="static-hero"
      aria-label="Spa ambience with relaxing atmosphere"
    >
      {/* Background image container */}
      <div
        className="static-hero__background"
        style={{ backgroundImage: `url("${IMG}")` }}
        aria-hidden="true"
      />

      {/* Multi-layer overlays for depth */}
      <div className="static-hero__overlay" aria-hidden="true" />
      <div className="static-hero__gradient-overlay" aria-hidden="true" />
      <div className="static-hero__vignette" aria-hidden="true" />

      {/* Animated background particles */}
      <div className="static-hero__particles" aria-hidden="true">
        <div className="static-hero__particle static-hero__particle--1"></div>
        <div className="static-hero__particle static-hero__particle--2"></div>
        <div className="static-hero__particle static-hero__particle--3"></div>
        <div className="static-hero__particle static-hero__particle--4"></div>
      </div>

      <div className={`static-hero__content ${isVisible ? 'is-visible' : ''}`}>
        {/* Main quote */}
        <div className="static-hero__quote">
          <h2 className="static-hero__title">
            <span className="static-hero__title-line">Wellbeing Starts</span>
            <span className="static-hero__title-line static-hero__title-line--accent">With
              Caring For Yourself</span>
          </h2>
        </div>

        {/* Subtitle with elegant divider */}
        <div className="static-hero__sub-container">
          <div className="static-hero__divider" aria-hidden="true">
            <div className="static-hero__divider-line"></div>
            <div className="static-hero__divider-dot"></div>
            <div className="static-hero__divider-line"></div>
          </div>
          <p className="static-hero__sub">
            Find Peace in Each Moment and Relief in Every Session
          </p>
        </div>

        {/* Signature element */}
        <div className="static-hero__signature" aria-hidden="true">
          <div className="static-hero__signature-line"></div>
          <span className="static-hero__signature-text">A Peaceful Retreat</span>
          <div className="static-hero__signature-line"></div>
        </div>
      </div>
    </section>
  );
}